import { Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { ILocalizacao } from "../../../../../../../application/models"
// Icon
import LocationOnIcon from '@mui/icons-material/LocationOn'

export const RecorteLocalizacaoFilterPreview = (props: {
    localizacaoFilter?: ILocalizacao[]
}) => {

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2} p={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Localização
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack
                            direction="row"
                            flexWrap="wrap"
                        >
                            {props.localizacaoFilter && props.localizacaoFilter.map((localizacao, i) => (
                                <Chip
                                    key={i}
                                    icon={<LocationOnIcon />}
                                    label={
                                        localizacao.value ?
                                            localizacao.categoria && localizacao.categoria === 'bairro' ? `${localizacao.bairro} - ${localizacao.cidade} / ${localizacao.uf}`
                                                : localizacao.value.toUpperCase()
                                            : ''
                                    }
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            ))}
                        </Stack>
                    </Grid>
                </Paper>
            </Grid>
        </>
    )
}